// extracted by css-extract-rspack-plugin
export default {"container":"FolderPicker_container_Sym3F","separator":"FolderPicker_separator_Wft8D","more":"FolderPicker_more_vraS2"};